/**
 * Drip — Lenis smooth scroll
 * Mobile only — desktop uses native scroll (Lenis + sticky stack + GLB = heavy lag).
 *
 * NOTE: Lenis CSS sets `.lenis.lenis-smooth iframe { pointer-events: none }`
 * which blocks Shiprocket / FASTRR. Overridden in drip-mode-overrides.css.
 */
(function () {
  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  let lenis = null;
  let iframeGuardsBound = false;

  function isThirdPartyEmbed(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.nodeName === 'IFRAME') return true;
    try {
      if (
        node.closest(
          'iframe, [data-lenis-prevent], [data-lenis-prevent-wheel], [data-lenis-prevent-touch],' +
            ' [id*="shiprocket" i], [class*="shiprocket" i],' +
            ' [id*="fastrr" i], [class*="fastrr" i],' +
            ' [id*="sr-widget" i], [class*="sr-widget" i]'
        )
      ) {
        return true;
      }
    } catch (_) {
      if (
        node.closest(
          'iframe, [data-lenis-prevent], [data-lenis-prevent-wheel], [data-lenis-prevent-touch],' +
            ' [id*="shiprocket"], [class*="shiprocket"],' +
            ' [id*="fastrr"], [class*="fastrr"],' +
            ' [id*="sr-widget"], [class*="sr-widget"]'
        )
      ) {
        return true;
      }
    }
    return false;
  }

  function protectIframes(root) {
    (root || document).querySelectorAll('iframe').forEach(function (iframe) {
      iframe.style.pointerEvents = 'auto';
      var host = iframe.parentElement;
      if (host && !host.hasAttribute('data-lenis-prevent')) {
        host.setAttribute('data-lenis-prevent', '');
      }
    });
  }

  function destroy() {
    if (lenis) {
      try {
        lenis.destroy();
      } catch (_) {}
      lenis = null;
    }
    window.__dripLenis = null;
    document.documentElement.classList.remove('lenis', 'lenis-smooth');
  }

  function bindIframeGuardsOnce() {
    if (iframeGuardsBound) return;
    iframeGuardsBound = true;

    document.addEventListener(
      'mouseenter',
      function (e) {
        if (!lenis) return;
        if (e.target && e.target.nodeName === 'IFRAME') {
          try {
            lenis.stop();
          } catch (_) {}
        }
      },
      true
    );
    document.addEventListener(
      'mouseleave',
      function (e) {
        if (!lenis) return;
        if (e.target && e.target.nodeName === 'IFRAME') {
          try {
            lenis.start();
          } catch (_) {}
        }
      },
      true
    );
  }

  function init() {
    protectIframes(document);

    /* Desktop: native scroll only — biggest lag fix */
    if (DESKTOP.matches || REDUCE.matches || typeof Lenis === 'undefined') {
      destroy();
      return;
    }

    destroy();
    bindIframeGuardsOnce();

    const opts = {
      autoRaf: true,
      smoothWheel: true,
      lerp: 0.12,
      wheelMultiplier: 0.9,
      touchMultiplier: 1,
      anchors: true,
      syncTouch: false,
      autoToggle: true,
      prevent: function (node) {
        return isThirdPartyEmbed(node);
      },
    };

    lenis = new Lenis(opts);
    window.__dripLenis = lenis;
    document.documentElement.classList.add('lenis', 'lenis-smooth');
  }

  function boot() {
    if (typeof Lenis === 'undefined') {
      setTimeout(init, 50);
    } else {
      init();
    }

    if (typeof MutationObserver !== 'undefined') {
      var t = 0;
      var mo = new MutationObserver(function (mutations) {
        var addedIframe = false;
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (!node || node.nodeType !== 1) continue;
            if (node.nodeName === 'IFRAME' || (node.querySelector && node.querySelector('iframe'))) {
              addedIframe = true;
              break;
            }
          }
          if (addedIframe) break;
        }
        if (!addedIframe) return;
        clearTimeout(t);
        t = setTimeout(function () {
          protectIframes(document);
        }, 200);
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }

    window.addEventListener('resize', function () {
      const ae = document.activeElement;
      if (ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.isContentEditable)) {
        return;
      }
      if (document.querySelector('.rz-header[data-search-open], .rz-search.is-open')) {
        return;
      }
      clearTimeout(window.__dripLenisResize);
      window.__dripLenisResize = setTimeout(init, 200);
    });
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', init);
    if (REDUCE.addEventListener) REDUCE.addEventListener('change', init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
